import {CopilotKit} from "@copilotkit/react-core/v2";
import {useGetCsrfToken, useGetSession} from "@project/application";
import {env} from "@project/env";
import {useMemo} from "react";

interface CopilotKitProviderProps {
  children?: React.ReactNode;
}

export function CopilotKitProvider({children}: CopilotKitProviderProps) {
  // Use VITE_AI_RUNTIME_URL from env, fallback to the local mock server
  const runtimeUrl = env.VITE_AI_RUNTIME_URL || "/agui";
  const showDevConsole = env.VITE_COPILOTKIT_DEVTOOLS === "true";
  const {data: session} = useGetSession();
  const authenticated = session?.authenticated === true;
  const {data: csrfToken} = useGetCsrfToken(authenticated);
  const headers = useMemo((): Record<string, string> => {
    if (!authenticated || !csrfToken?.token) return {};
    if (new URL(runtimeUrl, window.location.href).origin !== window.location.origin) return {};
    return {"X-CSRF-TOKEN": csrfToken.token};
  }, [authenticated, csrfToken?.token, runtimeUrl]);

  return (
    <CopilotKit
      runtimeUrl={runtimeUrl}
      headers={headers}
      credentials="same-origin"
      useSingleEndpoint={false}
      enableInspector={showDevConsole}
    >
      {children}
    </CopilotKit>
  );
}
